<template>
  <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-xs-12">
    <q-card class="shadow-3 h-180" square>
      <q-card-section class="bg-primary text-white flexbox">
        <div class="company-header">
          <div class="company-title">{{ localCompany.name }}</div>
          <div>
            <q-badge color="info">
              {{ localCompany.package.name }}
              <q-tooltip>
                <div>Package Type</div>
              </q-tooltip>
            </q-badge>
          </div>
        </div>
      </q-card-section>
      <div class="company-content">
        <div>
          <strong style="margin-bottom: 5px;">Subscription</strong>
          <div v-if="localCompany.subscription">
            <div v-if="localCompany.subscription.plan">
              <div>
                <strong>Plan:</strong> {{ localCompany.subscription.plan.name }} -
                {{ localCompany.subscription.plan.price.amount | formatPrice }}/{{
                  localCompany.subscription.plan.price.interval
                }}
              </div>
              <div v-if="localCompany.subscription.plan.limit && localCompany.subscription.plan.usage_based_price">
                <small style="color: #ff5f37;">Additional vehicles beyond {{ localCompany.subscription.plan.limit }}
                  will be charged
                  {{ localCompany.subscription.plan.usage_based_price.amount | formatPrice }} per vehicle
                  monthly.</small>
              </div>
            </div>
            <div>
              <strong>Status:</strong>
              <q-badge :color="subscriptionStatusByValue(localCompany.subscription.status).color"
                       style="margin-left: 5px;">
                {{ subscriptionStatusByValue(localCompany.subscription.status).label }}
              </q-badge>
            </div>
            <div>
              <strong>Ends:</strong>
              <span v-if="localCompany.subscription.end_date">{{
                  localCompany.subscription.end_date | dateTimeFormat
                }}</span>
              <span v-else>-</span>
            </div>
            <div v-if="localCompany.subscription.is_cancelable" style="margin-top: 5px;">
              <q-btn size="sm"
                     color="red"
                     @click="cancelSubscription(localCompany.id)"
                     :disable="loading"
                     :loading="loading">
                Cancel
              </q-btn>
            </div>
            <div v-else-if="localCompany.subscription.is_renewable"
                 style="margin-top: 5px;">
              <q-btn size="sm"
                     color="green"
                     @click="subscribe(localCompany)"
                     :disable="loading"
                     :loading="loading">
                Subscribe
              </q-btn>
            </div>
            <div v-else-if="localCompany.subscription.is_resumable"
                 style="margin-top: 5px;">
              <q-btn size="sm"
                     color="green"
                     @click="subscribe(localCompany)"
                     :disable="loading"
                     :loading="loading">
                Resume Subscription
              </q-btn>
            </div>
          </div>
          <div v-else>
            <div>You have no subscription</div>
            <q-btn size="sm"
                   color="green"
                   @click="subscribe(localCompany)"
                   :disable="loading"
                   :loading="loading">
              Subscribe
            </q-btn>
          </div>
        </div>
      </div>
      <div class="actions-icon">
        <div class="created-at">
          <q-icon
              name="fas fa-calendar-plus"
              size="15px"
              color="grey-7"
          ></q-icon>
          {{ localCompany.created_at | createdFormat }}
        </div>
        <div class="icon-margin">
          <q-btn
              icon="fas fa-trash"
              @click="confirmAction(company)"
              size="xs"
              color="red"
              round
          ></q-btn>
        </div>
        <div>
          <q-btn
              icon="fas fa-edit"
              @click="editAction(company)"
              size="xs"
              color="positive"
              round
          ></q-btn>
        </div>
        <div class="icon-margin">
          <q-tooltip>
            Locations
          </q-tooltip>
          <q-btn
              @click="companyLocations(company)"
              icon="fas fa-map-marker"
              round
              color="info"
              size="xs"
          ></q-btn>
        </div>
        <div>
          <q-tooltip>
            Groups
          </q-tooltip>
          <q-btn
              @click="companyVehicleGroups(company)"
              icon="fas fa-object-group"
              round
              color="orange"
              size="xs"
          ></q-btn>
        </div>
        <div class="icon-margin">
          <q-tooltip>
            Advent Resource
          </q-tooltip>
          <q-btn
              @click="companyAdventResource(company)"
              icon="fas fa-file-import"
              round
              color="primary"
              size="xs"
          ></q-btn>
        </div>
        <div>
          <q-tooltip>
            Fleet Market Hub
          </q-tooltip>
          <q-btn
              @click="companyFmhToken(company)"
              icon="fas fa-car"
              round
              color="primary"
              size="xs"
          ></q-btn>
        </div>
      </div>
    </q-card>
    <advent-resource-dialog></advent-resource-dialog>
    <fmh-token-dialog></fmh-token-dialog>
  </div>
</template>

<script>
import Confirm from "./Confirm";
import AdventResourceDialog from "@/components/AdventResourceDialog.vue";
import FmhTokenDialog from "@/components/FmhTokenDialog.vue";
import {subscriptionStatusByValue} from "@/enums";
import axiosInstance from "@/axios";

export default {
  components: {
    AdventResourceDialog,
    FmhTokenDialog,
    Confirm,
  },
  props: {
    company: Object,
    index: Number,
  },
  data() {
    return {
      localCompany: {...this.company},
      loading: false,
    };
  },
  methods: {
    subscriptionStatusByValue,
    companyLocations(company) {
      this.$router.push({name: "locations", params: {id: this.localCompany.id}});
    },
    companyVehicleGroups(company) {
      this.$router.push({name: "groups", params: {companyId: this.localCompany.id}});
    },
    companyAdventResource(company) {
      this.setAdventResourceDialog = {
        show: true,
        company: company,
      }
    },
    companyFmhToken(company) {
      this.setFmhTokenDialog = {
        show: true,
        company: company,
      }
    },
    editAction(val) {
      this.edit = true;
      this.selectedCompany = val;
    },
    confirmAction(val) {
      this.selectedCompany = val;
      this.confirm = true;
    },
    subscribe(company) {
      let message = `You are about to subscribe to the plan: ${company.subscription.plan.name}. This will charge you ${company.subscription.plan.price.amount} ${company.subscription.plan.price.currency} per ${company.subscription.plan.price.interval}.`;
      if (company.subscription.plan.limit && company.subscription.plan.usage_based_price) {
        message += ` Additional vehicles beyond ${company.subscription.plan.limit} will be charged ${company.subscription.plan.usage_based_price.amount} ${company.subscription.plan.price.currency} per vehicle monthly.`;
      }
      message += ` Are you sure you want to proceed?`;

      this.$q.dialog({
        title: 'Confirm Subscription',
        message: message,
        cancel: true,
        persistent: true
      }).onOk(async () => {
        try {
          this.loading = true;
          const {data} = await axiosInstance.put('subscriptions', {company: company.id});

          if (data.data.url && data.data.url !== '') {
            window.open(data.data.url, '_self');
            return
          }

          setTimeout(async () => {
            this.$q.notify({
              message: 'Subscription successful. Please wait for the company to be updated.',
              timeout: 250,
              position: "top-right",
              progress: true,
              type: "positive"
            });

            setTimeout(async () => {
              window.location.reload();
            }, 3000);
          }, 3000);
        } catch (error) {
          let message = 'We can not subscribe to the localCompany. Something went wrong.';
          if (error.response && error.response.data && error.response.data.message) {
            message = error.response.data.message;
          }

          this.$q.notify({
            message: message,
            timeout: 250,
            position: "top-right",
            progress: true,
            type: "negative"
          });

          this.loading = false;
        }
      });
    },
    cancelSubscription(companyId) {
      this.$q.dialog({
        title: 'Confirm Cancellation',
        message: 'Are you sure you want to cancel this subscription?',
        cancel: true,
        persistent: true
      }).onOk(async () => {
        try {
          this.loading = true;
          const {data} = await axiosInstance.post('subscriptions/cancel', {company: companyId});

          setTimeout(async () => {
            this.$q.notify({
              message: data.message,
              timeout: 250,
              position: "top-right",
              progress: true,
              type: "positive"
            });

            setTimeout(async () => {
              window.location.reload();
            }, 3000);
          }, 3000);
        } catch (error) {
          let message = 'We can not cancel the subscription. Something went wrong.';
          if (error.response && error.response.data && error.response.data.message) {
            message = error.response.data.message;
          }

          this.$q.notify({
            message: message,
            timeout: 250,
            position: "top-right",
            progress: true,
            type: "negative"
          });

          this.loading = false;
        }
      });
    },
    async refetchCompany(companyId) {
      try {
        this.loading = true;
        const {data} = await axiosInstance.get(`/company/${companyId}`);
        this.company = data.data;
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false;
      }
    },
    checkSubscriptionStatus() {
      const query = this.$route.query;
      if (query.provider === 'stripe' && query.subscription) {
        if (query.status === 'success') {
          this.$q.notify({
            message: 'Subscription successful. Thank you for your purchase!',
            color: 'green',
            position: 'top-right',
            timeout: 4000,
            progress: true,
            type: 'positive'
          });
        } else if (query.status === 'failed') {
          this.$q.notify({
            message: 'Subscription failed. Please try again or contact support.',
            color: 'red',
            position: 'top-right',
            timeout: 4000,
            progress: true,
            type: 'negative'
          });
        }

        this.$router.replace({query: {}});
      }
    }
  },
  computed: {
    confirm: {
      get() {
        return this.$store.state.company.confirm;
      },
      set(val) {
        this.$store.commit("company/SET_CONFIRM", val);
      },
    },
    selectedCompany: {
      get() {
        return this.$store.state.company.selectedCompany;
      },
      set(val) {
        this.$store.commit("company/SET_SELECTED_COMPANY", val);
      },
    },
    edit: {
      get() {
        return this.$store.state.company.edit;
      },
      set(val) {
        this.$store.commit("company/SET_EDIT", val);
      },
    },
    setAdventResourceDialog: {
      get() {
        return this.$store.state.company.setAdventResourceDialog
      },
      set(val) {
        this.$store.commit('company/SET_ADVENT_RESOURCE_DIALOG', val)
      }
    },
    setFmhTokenDialog: {
      get() {
        return this.$store.state.company.setFmhTokenDialog
      },
      set(val) {
        this.$store.commit('company/SET_FMH_TOKEN_DIALOG', val)
      }
    },
  },
  mounted() {
    this.checkSubscriptionStatus();
  }
};
</script>
